module.exports = __webpack_public_path__ + "img/services-offered-display.0c2f78e0.png";